import { render, staticRenderFns } from "./tracked-link.vue?vue&type=template&id=72d13760"
import script from "./tracked-link.vue?vue&type=script&lang=js"
export * from "./tracked-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports